import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
export const AddStudyConfirmAndAddDialogContentImage = styled.img `
    max-width: 172px;
    max-height: 172px;
`;
export const AddStudyConfirmAndAddDialogContentTitle = styled.div `
    font-size: ${fontSizes.SUPER};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const AddStudyConfirmAndAddDialogContentText = styled.div `
    text-align: center;
`;
